module.exports = __webpack_public_path__ + "static/media/konf-room2.c6da64bf.jpg";